// TODO: Celou anketu začistit proti "as Type" assertům, pravděpodobně spolu s testy
// TODO: Refaktorovat a oddělit logiku hlasování od logiky zobrazování výsledků

import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
import {
  CLASS_ANSWERS,
  CLASS_FOOTER_NOTICE,
  sessionData,
} from '@box/article/EnquiryBars/enquiryCommons';
import { handleError, checkResponseError } from '@box/article/EnquiryBars/errorHandling';
import { updateUrl, UpdateJson, EnquiryQuestion } from '@box/article/EnquiryBars/enquiryApi';
import showResult from '@box/article/EnquiryBars/showResult';
import showLoginLink from '@box/article/EnquiryBars/showLoginLink';
import { voteHandler } from '@box/article/EnquiryBars/voteHandler';

type EnquiryDataset = {
  questionId: string;
  questionText: string;
};

/**
 * @name enquiryBars
 * @description Zobrazí ankety, každá po jedné otázce s pruhovými odpověďmi.
 * Jednotlivá anketa může nabývat několika stavů. Pokud uživatel není přihlášen, zobrazí se po hlasování výzva k přihlášení.
 * Výsledky hlasování se zobrazí až po přihlášení a tedy přesměrování z Porty, stránka zascrolluje k anketě, ve které uživatel hlasoval.
 * Pokud uživatel přihlášen je, zobrazí se přímo výsledky hlasování. V tomto případě se použijí data vrácená jako odpověď na zaslání hlasu na BE.
 *
 * @param {NodeListOf<HTMLElement>} enquiries Jednotlivé ankety.
 */
export const enquiryBars = (enquiries: NodeListOf<HTMLElement>) => {
  enquiries.forEach((enquiry) => {
    const question: HTMLDivElement | null = enquiry.querySelector('[data-question-id]');

    // Pokud nemáme otázku, nemá smysl anketu vytvářet
    if (!question) return;

    const answersWrapper = enquiry.querySelector(`.${CLASS_ANSWERS}`) as HTMLDivElement;
    const voteNotice = enquiry.querySelector(`.${CLASS_FOOTER_NOTICE}`) as HTMLDivElement;
    const isLogged = Boolean(enquiry.dataset.isLogged);
    const enquiryEnabled = Boolean(enquiry.dataset.enquiryEnabled);
    const answers: NodeListOf<HTMLDivElement> = enquiry.querySelectorAll('[data-answer-id]');
    const { questionId, questionText } = question.dataset as EnquiryDataset;
    const selectedAnswerCookie: string | undefined = Cookies.get(`enquiry-${questionId}`);

    // Pokud nemáme cookie a anketa je aktivní, nastaví se anketa (statická HTML šablona) tak, aby hlasovat mohl.
    if (enquiryEnabled && typeof selectedAnswerCookie === 'undefined') {
      answersWrapper.addEventListener('click', function voteHandlerListener(event) {
        voteHandler(
          event,
          enquiry,
          answersWrapper,
          voteNotice,
          questionId,
          questionText,
          isLogged,
          enquiryEnabled,
          answers,
          voteHandlerListener
        );
      });
      return;
    }

    // Pokud uživatel není přihlášeni, zobrazí se výzva k přihlášení.
    if (!isLogged) {
      showLoginLink(enquiry, answersWrapper, voteNotice, questionId, questionText, enquiryEnabled);
      return;
    }

    // Pokud se uživatel vrací z externího přihlášení (porty) zascrolluje se k anketě, ze které na přihlášení odešel.
    if (sessionData.getItem('userLoggingFrom') === questionId) {
      enquiry.scrollIntoView();
      sessionData.removeItem('userLoggingFrom');
    }

    // Pokud je uživatel přihlášen, zobrazí se výsledky odpovědí.
    const resultEnquiryId = enquiry.dataset.enquiryId as string;
    const fetchedResultUrl = updateUrl(resultEnquiryId);
    fetch(fetchedResultUrl)
      .then((response) => {
        checkResponseError(response.status);
        response
          .json()
          .then((updateData) => {
            const jsonDataUpdate = updateData as UpdateJson;
            const questionUpdatedData = jsonDataUpdate[resultEnquiryId][questionId];

            answers.forEach((answer) => {
              const percValue = (questionUpdatedData as EnquiryQuestion)[
                answer.dataset.answerId as string
              ].qperc_val;
              const percent = `${Math.round(parseInt(percValue, 10))}%`;

              showResult(answer, percent, selectedAnswerCookie);
            });
          })
          .catch((err) => {
            Sentry.captureException(err);
          });
      })
      .catch((err) => {
        Sentry.captureException(err);
        if (err instanceof Error) {
          handleError(err.message, voteNotice);
        }
      });
  });
};
